module.exports = ".error {\n  color: red;\n  font-size: 12px;\n  margin-left: 20px; }\n\nmat-form-field {\n  height: 70px; }\n"